<template>
  <div class="pt-4">
    <v-row>
      <v-col cols="6" class="pa-0">
        <div class="d-inline-flex align-center">
          <i class="icon-camera font-size-26 mr-2"></i>
          <span class="text-body-2">{{
            photo.metadata && photo.metadata.model
              ? photo.metadata.model
              : 'N/A'
          }}</span>
        </div>
      </v-col>
      <v-col cols="6" class="pa-0">
        <div class="d-inline-flex align-center">
          <i class="icon-lens font-size-26 mr-2"></i>
          <span class="text-body-2">{{
            photo.metadata && photo.metadata.focalLength
              ? photo.metadata.focalLength
              : 'N/A'
          }}</span>
        </div>
      </v-col>
      <v-col cols="6" class="pa-0">
        <div class="d-inline-flex align-center">
          <i class="icon-aperture font-size-26 mr-2"></i>
          <span class="text-body-2">{{
            photo.metadata && photo.metadata.aperture
              ? photo.metadata.aperture
              : 'N/A'
          }}</span>
        </div>
      </v-col>
      <v-col cols="6" class="pa-0">
        <div class="d-inline-flex align-center">
          <i class="icon-shutter font-size-26 mr-2"></i>
          <span class="text-body-2">{{
            photo.metadata && photo.metadata.exposureTime
              ? photo.metadata.exposureTime
              : 'N/A'
          }}</span>
        </div>
      </v-col>
      <v-col cols="6" class="pa-0">
        <div class="d-inline-flex align-center">
          <i class="icon-iso font-size-26 mr-2"></i>
          <span class="text-body-2">{{
            photo.metadata && photo.metadata.iso ? photo.metadata.iso : 'N/A'
          }}</span>
        </div>
      </v-col>
      <v-col cols="6" class="pa-0">
        <div class="d-inline-flex align-center">
          <i class="fal fa-clock fa-fix-size mr-2"></i>
          <span
            v-if="photo.metadata && photo.metadata.dateTime"
            class="text-body-2"
            >{{ photo.metadata.dateTime | printdate }}</span
          >
          <span v-else class="text-body-2">N/A</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'CurationPanelExif',
  filters: {
    printdate: date => {
      const d = date.split(' ')
      const dmy = d[0].replace(':', '-')
      const newDate = `${dmy} ${d[1]}`
      return moment(newDate).format('D MMMM YYYY - HH:mm')
    }
  },
  props: {
    photo: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
.font-size-26 {
  font-size: 26px;
}
.fa-fix-size {
  font-size: 13px;
  line-height: 24px;
  width: 30px;
  text-align: center;
}
</style>
